"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultTransceiverController = /*#__PURE__*/function () {
  function DefaultTransceiverController(logger, browserBehavior) {
    _classCallCheck(this, DefaultTransceiverController);

    this.logger = logger;
    this.browserBehavior = browserBehavior;
    this._localCameraTransceiver = null;
    this._localAudioTransceiver = null;
    this.videoSubscriptions = [];
    this.defaultMediaStream = null;
    this.peer = null;
    this.streamIdToTransceiver = new Map();
  }

  _createClass(DefaultTransceiverController, [{
    key: "setEncodingParameters",
    value: function setEncodingParameters(encodingParamMap) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var sender, newEncodingParams, oldParam, _iterator, _step, existing, _iterator2, _step2, changed, key;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv')) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                sender = this._localCameraTransceiver.sender;

                if (!(!encodingParamMap || encodingParamMap.size === 0)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                newEncodingParams = Array.from(encodingParamMap.values());
                oldParam = sender.getParameters();

                if (!(!oldParam.encodings || oldParam.encodings.length === 0)) {
                  _context.next = 11;
                  break;
                }

                oldParam.encodings = newEncodingParams;
                _context.next = 52;
                break;

              case 11:
                _iterator = _createForOfIteratorHelper(oldParam.encodings);
                _context.prev = 12;

                _iterator.s();

              case 14:
                if ((_step = _iterator.n()).done) {
                  _context.next = 44;
                  break;
                }

                existing = _step.value;
                _iterator2 = _createForOfIteratorHelper(newEncodingParams);
                _context.prev = 17;

                _iterator2.s();

              case 19:
                if ((_step2 = _iterator2.n()).done) {
                  _context.next = 34;
                  break;
                }

                changed = _step2.value;

                if (!((existing.rid || changed.rid) && existing.rid !== changed.rid)) {
                  _context.next = 23;
                  break;
                }

                return _context.abrupt("continue", 32);

              case 23:
                key = void 0;
                _context.t0 = _regenerator.default.keys(changed);

              case 25:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 32;
                  break;
                }

                key = _context.t1.value;

                if (!(key === 'rid' || key === 'codecPayloadType')) {
                  _context.next = 29;
                  break;
                }

                return _context.abrupt("continue", 25);

              case 29:
                /* istanbul ignore else */
                if (changed.hasOwnProperty(key)) {
                  existing[key] = changed[key];
                }

                _context.next = 25;
                break;

              case 32:
                _context.next = 19;
                break;

              case 34:
                _context.next = 39;
                break;

              case 36:
                _context.prev = 36;
                _context.t2 = _context["catch"](17);

                _iterator2.e(_context.t2);

              case 39:
                _context.prev = 39;

                _iterator2.f();

                return _context.finish(39);

              case 42:
                _context.next = 14;
                break;

              case 44:
                _context.next = 49;
                break;

              case 46:
                _context.prev = 46;
                _context.t3 = _context["catch"](12);

                _iterator.e(_context.t3);

              case 49:
                _context.prev = 49;

                _iterator.f();

                return _context.finish(49);

              case 52:
                _context.next = 54;
                return sender.setParameters(oldParam);

              case 54:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[12, 46, 49, 52], [17, 36, 39, 42]]);
      }));
    }
  }, {
    key: "localAudioTransceiver",
    value: function localAudioTransceiver() {
      return this._localAudioTransceiver;
    }
  }, {
    key: "localVideoTransceiver",
    value: function localVideoTransceiver() {
      return this._localCameraTransceiver;
    }
  }, {
    key: "setVideoSendingBitrateKbps",
    value: function setVideoSendingBitrateKbps(bitrateKbps) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var sender;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                sender = this._localCameraTransceiver.sender;
                _context2.next = 5;
                return DefaultTransceiverController.setVideoSendingBitrateKbpsForSender(sender, bitrateKbps, this.logger);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "setPeer",
    value: function setPeer(peer) {
      this.peer = peer;
    }
  }, {
    key: "reset",
    value: function reset() {
      this._localCameraTransceiver = null;
      this._localAudioTransceiver = null;
      this.videoSubscriptions = [];
      this.defaultMediaStream = null;
      this.peer = null;
    }
  }, {
    key: "useTransceivers",
    value: function useTransceivers() {
      if (!this.peer || !this.browserBehavior.requiresUnifiedPlan()) {
        return false;
      }

      return typeof this.peer.getTransceivers !== 'undefined';
    }
  }, {
    key: "hasVideoInput",
    value: function hasVideoInput() {
      if (!this._localCameraTransceiver || this._localCameraTransceiver.direction !== 'sendrecv') return false;
      return true;
    }
  }, {
    key: "trackIsVideoInput",
    value: function trackIsVideoInput(track) {
      if (!this._localCameraTransceiver) {
        return false;
      }

      return track === this._localCameraTransceiver.sender.track || track === this._localCameraTransceiver.receiver.track;
    }
  }, {
    key: "setupLocalTransceivers",
    value: function setupLocalTransceivers() {
      if (!this.useTransceivers()) {
        return;
      }

      if (!this.defaultMediaStream && typeof MediaStream !== 'undefined') {
        this.defaultMediaStream = new MediaStream();
      }

      if (!this._localAudioTransceiver) {
        this._localAudioTransceiver = this.peer.addTransceiver('audio', {
          direction: 'inactive',
          streams: [this.defaultMediaStream]
        });
      }

      if (!this._localCameraTransceiver) {
        this._localCameraTransceiver = this.peer.addTransceiver('video', {
          direction: 'inactive',
          streams: [this.defaultMediaStream]
        });
      }
    }
  }, {
    key: "replaceAudioTrack",
    value: function replaceAudioTrack(track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!this._localAudioTransceiver || this._localAudioTransceiver.direction !== 'sendrecv')) {
                  _context3.next = 3;
                  break;
                }

                this.logger.info("audio transceiver direction is not set up or not activated");
                return _context3.abrupt("return", false);

              case 3:
                _context3.next = 5;
                return this._localAudioTransceiver.sender.replaceTrack(track);

              case 5:
                return _context3.abrupt("return", true);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "setAudioInput",
    value: function setAudioInput(track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setTransceiverInput(this._localAudioTransceiver, track);

              case 2:
                return _context4.abrupt("return");

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "setVideoInput",
    value: function setVideoInput(track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setTransceiverInput(this._localCameraTransceiver, track);

              case 2:
                return _context5.abrupt("return");

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "updateVideoTransceivers",
    value: function updateVideoTransceivers(videoStreamIndex, videosToReceive) {
      var _this = this;

      if (!this.useTransceivers()) {
        return videosToReceive.array();
      } // See https://blog.mozilla.org/webrtc/rtcrtptransceiver-explored/ for details on transceivers


      var transceivers = this.peer.getTransceivers(); // Subscription index 0 is reserved for transmitting camera.
      // We mark inactive slots with 0 in the subscription array.

      this.videoSubscriptions = [0];
      videosToReceive = videosToReceive.clone();
      this.updateTransceivers(transceivers, videoStreamIndex, videosToReceive);
      this.logger.debug(function () {
        return _this.debugDumpTransceivers();
      });
      return this.videoSubscriptions;
    }
  }, {
    key: "updateTransceivers",
    value: function updateTransceivers(transceivers, videoStreamIndex, videosToReceive) {
      var videosRemaining = videosToReceive.array(); // Start by handling existing videos
      // Begin counting out index in the the subscription array at 1 since the camera.
      // Always occupies position 0 (whether active or not).

      var n = 1;

      var _iterator3 = _createForOfIteratorHelper(transceivers),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var transceiver = _step3.value;

          if (transceiver === this._localCameraTransceiver || !this.transceiverIsVideo(transceiver)) {
            continue;
          }

          this.videoSubscriptions[n] = 0;

          if (transceiver.direction !== 'inactive') {
            // See if we want this existing transceiver
            // by convention with the video host, msid is equal to the media section mid, prefixed with the string "v_"
            // we use this to get the streamId for the track
            var streamId = videoStreamIndex.streamIdForTrack('v_' + transceiver.mid);

            if (streamId !== undefined) {
              var _iterator6 = _createForOfIteratorHelper(videosRemaining.entries()),
                  _step6;

              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var _ref3 = _step6.value;

                  var _ref2 = _slicedToArray(_ref3, 2);

                  var index = _ref2[0];
                  var recvStreamId = _ref2[1];

                  if (videoStreamIndex.StreamIdsInSameGroup(streamId, recvStreamId)) {
                    transceiver.direction = 'recvonly';
                    this.videoSubscriptions[n] = recvStreamId;
                    this.streamIdToTransceiver.delete(streamId);
                    this.streamIdToTransceiver.set(recvStreamId, transceiver);
                    videosRemaining.splice(index, 1);
                    break;
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            }
          }

          n += 1;
        } // Next fill in open slots and remove unused

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      n = 1;

      var _iterator4 = _createForOfIteratorHelper(transceivers),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _transceiver = _step4.value;

          if (_transceiver === this._localCameraTransceiver || !this.transceiverIsVideo(_transceiver)) {
            continue;
          }

          if (_transceiver.direction === 'inactive' && videosRemaining.length > 0) {
            // Fill available slot
            _transceiver.direction = 'recvonly';

            var _streamId = videosRemaining.shift();

            this.videoSubscriptions[n] = _streamId;
            this.streamIdToTransceiver.set(_streamId, _transceiver);
          } else {
            // Remove if no longer subscribed
            if (this.videoSubscriptions[n] === 0) {
              _transceiver.direction = 'inactive';

              var _iterator7 = _createForOfIteratorHelper(this.streamIdToTransceiver.entries()),
                  _step7;

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  var _ref6 = _step7.value;

                  var _ref5 = _slicedToArray(_ref6, 2);

                  var _streamId2 = _ref5[0];
                  var previousTransceiver = _ref5[1];

                  if (_transceiver === previousTransceiver) {
                    this.streamIdToTransceiver.delete(_streamId2);
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
            }
          }

          n += 1;
        } // add transceivers for the remaining subscriptions

      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      var _iterator5 = _createForOfIteratorHelper(videosRemaining),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _index = _step5.value;

          // @ts-ignore
          var _transceiver2 = this.peer.addTransceiver('video', {
            direction: 'recvonly',
            streams: [this.defaultMediaStream]
          });

          this.streamIdToTransceiver.set(_index, _transceiver2);
          this.videoSubscriptions.push(_index);
          this.logger.info("adding transceiver mid: ".concat(_transceiver2.mid, " subscription: ").concat(_index, " direction: recvonly"));
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "getMidForStreamId",
    value: function getMidForStreamId(streamId) {
      var _a;

      return (_a = this.streamIdToTransceiver.get(streamId)) === null || _a === void 0 ? void 0 : _a.mid;
    }
  }, {
    key: "setStreamIdForMid",
    value: function setStreamIdForMid(mid, newStreamId) {
      var _iterator8 = _createForOfIteratorHelper(this.streamIdToTransceiver.entries()),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _ref9 = _step8.value;

          var _ref8 = _slicedToArray(_ref9, 2);

          var streamId = _ref8[0];
          var transceiver = _ref8[1];

          if (transceiver.mid === mid) {
            this.streamIdToTransceiver.delete(streamId);
            this.streamIdToTransceiver.set(newStreamId, transceiver);
            return;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "transceiverIsVideo",
    value: function transceiverIsVideo(transceiver) {
      return transceiver.receiver && transceiver.receiver.track && transceiver.receiver.track.kind === 'video' || transceiver.sender && transceiver.sender.track && transceiver.sender.track.kind === 'video';
    }
  }, {
    key: "debugDumpTransceivers",
    value: function debugDumpTransceivers() {
      var msg = '';
      var n = 0;

      var _iterator9 = _createForOfIteratorHelper(this.peer.getTransceivers()),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var transceiver = _step9.value;

          if (!this.transceiverIsVideo(transceiver)) {
            continue;
          }

          msg += "transceiver index=".concat(n, " mid=").concat(transceiver.mid, " subscription=").concat(this.videoSubscriptions[n], " direction=").concat(transceiver.direction, "\n");
          n += 1;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return msg;
    }
  }, {
    key: "setTransceiverInput",
    value: function setTransceiverInput(transceiver, track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee6() {
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (transceiver) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return");

              case 2:
                if (track) {
                  transceiver.direction = 'sendrecv';
                } else {
                  transceiver.direction = 'inactive';
                }

                _context6.next = 5;
                return transceiver.sender.replaceTrack(track);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    }
  }], [{
    key: "setVideoSendingBitrateKbpsForSender",
    value: function setVideoSendingBitrateKbpsForSender(sender, bitrateKbps, _logger) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee7() {
        var param, _iterator10, _step10, encodeParam;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(!sender || bitrateKbps <= 0)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                param = sender.getParameters();

                if (!param.encodings) {
                  param.encodings = [{}];
                }

                _iterator10 = _createForOfIteratorHelper(param.encodings);

                try {
                  for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                    encodeParam = _step10.value;
                    encodeParam.maxBitrate = bitrateKbps * 1000;
                  }
                } catch (err) {
                  _iterator10.e(err);
                } finally {
                  _iterator10.f();
                }

                _context7.next = 8;
                return sender.setParameters(param);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    }
  }, {
    key: "replaceAudioTrackForSender",
    value: function replaceAudioTrackForSender(sender, track) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee8() {
        return _regenerator.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (sender) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt("return", false);

              case 2:
                _context8.next = 4;
                return sender.replaceTrack(track);

              case 4:
                return _context8.abrupt("return", true);

              case 5:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  }]);

  return DefaultTransceiverController;
}();

exports.default = DefaultTransceiverController;